import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
export default class DeluxePlayerControlsComponent extends Component {
  @service stereo;

  @tracked index = 1;
  speeds = [0.8, 1.0, 1.25, 1.5, 2.0];

  get speed() {
    return this.speeds[this.index % this.speeds.length];
  }

  @action
  changePlaybackSpeed() {
    this.index = this.index + 1;
    this.stereo.playbackSpeed = this.speed;
  }

  @action
  setPlaybackSpeed(speed) {
    this.stereo.playbackSpeed = speed;
  }
}
